export class StatusResponse {
    status: boolean;
    message: string;

    constructor({
        status = false,
        message = ""
    }) {
        this.status = status;
        this.message = message;
    }
}